import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Account, AccountService, AuditService, GroupOrder, GroupOrderService, Order, OrderService, Upsell } from 'ngx-web-api';
import { GroupOrderOrchestratorService } from '../../core/services/group-order-orchestrator.service';
import { MenuWrapperService } from '../../core/services/menu-wrapper.service';
import { OrderUpsellService } from '../../core/services/order-upsell.service';
import { ThemeService } from '../../core/services/theme.service';
import { UiOrchestratorService } from '../../core/services/ui-orchestrator.service';
import { Theme } from '../../domain/theme.model';
import { take } from 'rxjs/operators';
import { BreakpointService } from '../../core/services/breakpoint.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CheckoutUpsellsModalContext } from 'app/domain/checkout-upsells-modal-context';

interface UpsellItemInfo {
  upsellItem: Upsell;
  title: string;
}

@Component({
  selector: 'fts-checkout-upsells-modal',
  templateUrl: './checkout-upsells-modal.component.html',
  styleUrls: ['./checkout-upsells-modal.component.scss'],
})
export class CheckoutUpsellsModalComponent implements OnInit {
  public context: CheckoutUpsellsModalContext;
  account: Account;
  upsellItemInfos: UpsellItemInfo[];
  groupOrder: GroupOrder;
  theme: Theme;
  order: Order;

  constructor(
    private auditService: AuditService,
    private accountService: AccountService,
    private groupOrderService: GroupOrderService,
    private groupOrderOrchestrationService: GroupOrderOrchestratorService,
    private router: Router,
    private uiOrchestratorService: UiOrchestratorService,
    private themeService: ThemeService,
    private orderService: OrderService,
    private menuService: MenuWrapperService,
    private orderUpsellService: OrderUpsellService,
    public breakPointService: BreakpointService,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.groupOrderService.groupOrder$.subscribe(g => (this.groupOrder = g));
    this.accountService.account$.subscribe(account => (this.account = account));
    this.themeService.theme.subscribe(theme => (this.theme = theme));
    this.orderService.order$.subscribe(order => (this.order = order));
    this.auditService.createAudit(() => `Checkout Upsell modal has been opened`);

    this.upsellItemInfos = this.context.upsellItemInfos;
    this.uiOrchestratorService.informModalOpened();
  }

  hideModal(shouldHide: boolean): void {
    if (shouldHide) {
      this.activeModal.close(false);
    }
  }

  handleNoThanks() {
    this.activeModal.close(false);
  }

  onItemAddedToOrder(result: string) {
    if (result) {
      this.orderUpsellService.addedUpsell = true;
      this.activeModal.close(true);

      if (this.groupOrder && this.groupOrder.isActive) {
        this.groupOrderOrchestrationService.handleReadyAction(this.groupOrder, this.menuService, false);
      } else {
        this.menuService
          .getFirstPanelItemName()
          .pipe(take(1))
          .subscribe(firstPanelName => {
            if (firstPanelName) {
              this.router.navigate(['/menu', firstPanelName]);
            } else {
              this.router.navigate(['/menu']);
            }
          });
      }
    }
  }
}
